import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const SplitIcon = withSvgIcon(
    <g>
        <path d="M242 183h18.8v57.8H242zM242 260h18.8v57.8H242zM242 356h18.8v38.8H242zM242 105.6h18.8v39.1H242z" />
        <path d="M432 68.6H260.8v-40H242v40H68v364h174v38.8h18.8v-38.8H432v-364zm-20 344H88v-324h324v324z" />
    </g>
);
